// src/data/comedians/paul-mirabel.js

const base = {
  id: 'paul-mirabel',
  slug: 'paul-mirabel',
  name: 'Paul Mirabel',
  birthYear: 1996,
  image: require('@/assets/images/img_Paul_Mirabel.jpg'),
  famousWorks: [
    'Zèbre',
    'Viral stand-up clips',
    'Live comedy shows',
  ],
};

export default [
  {
    ...base,
    lang: 'en',
    nationality: 'French',
    shortBio: 'Rising star of the new French stand-up generation',
    bio: `Paul Mirabel is one of the fastest-rising comedians in the French stand-up scene. His calm, awkward, and minimalist delivery contrasts sharply with traditional high-energy comedy styles, creating a unique comedic signature that has quickly resonated with audiences.\n\nBorn in 1996, Mirabel represents a new generation of French comedians who have built their following largely through social media and digital platforms. His clips regularly attract millions of views, making him a standout figure in modern French comedy.\n\nHis unique comedic voice — blending awkward silences, deadpan delivery, and absurd observations — has quickly earned him widespread recognition and sold-out shows across France.`,
    style: 'Minimalist humor, awkward delivery, absurd comedy, deadpan',
    achievements: [
      'Massive viral success on social media',
      'Sold-out shows nationwide',
      'Breakthrough figure of modern French stand-up',
    ],
  },
  {
    ...base,
    lang: 'fr',
    nationality: 'Français',
    shortBio: 'Étoile montante de la nouvelle génération du stand-up français',
    bio: `Paul Mirabel est l'un des comédiens qui monte le plus vite dans la scène stand-up française. Sa livraison calme, maladroite et minimaliste contraste fortement avec les styles de comédie traditionnels à haute énergie, créant une signature comique unique qui a rapidement trouvé un écho auprès du public.\n\nNé en 1996, Mirabel représente une nouvelle génération de comédiens français qui ont construit leur audience principalement grâce aux réseaux sociaux et aux plateformes numériques. Ses clips attirent régulièrement des millions de vues.\n\nSa voix comique unique — mêlant silences maladroits, livraison pince-sans-rire et observations absurdes — lui a rapidement valu une reconnaissance généralisée et des salles combles à travers la France.`,
    style: 'Humour minimaliste, livraison maladroite, comédie absurde, pince-sans-rire',
    achievements: [
      'Succès viral massif sur les réseaux sociaux',
      'Spectacles sold-out à l\'échelle nationale',
      'Figure révélatrice du stand-up français moderne',
    ],
  },
  {
    ...base,
    lang: 'es',
    nationality: 'Francés',
    shortBio: 'Estrella emergente de la nueva generación del stand-up francés',
    bio: `Paul Mirabel es uno de los comediantes que más rápido está ascendiendo en la escena del stand-up francés. Su entrega tranquila, torpe y minimalista contrasta fuertemente con los estilos de comedia tradicionales de alta energía, creando una firma cómica única que rápidamente ha resonado con el público.\n\nNacido en 1996, Mirabel representa una nueva generación de comediantes franceses que han construido su seguimiento principalmente a través de las redes sociales y plataformas digitales. Sus clips atraen regularmente millones de visitas.\n\nSu voz cómica única — mezclando silencios torpes, entrega en tono seco y observaciones absurdas — le ha valido rápidamente un amplio reconocimiento y espectáculos agotados en toda Francia.`,
    style: 'Humor minimalista, entrega torpe, comedia absurda, tono seco',
    achievements: [
      'Masivo éxito viral en redes sociales',
      'Espectáculos agotados en todo el país',
      'Figura revelación del stand-up francés moderno',
    ],
  },
  {
    ...base,
    lang: 'ar',
    nationality: 'فرنسي',
    shortBio: 'النجم الصاعد في جيل الستاند أب الفرنسي الجديد',
    bio: `بول ميرابيل أحد أسرع الكوميديين صعودًا في مشهد الستاند أب الفرنسي. أسلوبه الهادئ المحرج والمتقشف يتناقض بشكل حاد مع أساليب الكوميديا التقليدية مرتفعة الطاقة، ليصنع بصمة كوميدية فريدة سرعان ما أوجدت صدىً واسعًا لدى الجمهور.\n\nوُلد عام 1996 ويمثّل جيلاً جديدًا من الكوميديين الفرنسيين الذين بنوا جمهورهم أساسًا عبر وسائل التواصل الاجتماعي والمنصات الرقمية. تجذب مقاطعه باستمرار ملايين المشاهدات.\n\nصوته الكوميدي الفريد — يمزج بين الصمت المحرج والأداء المسطّح والملاحظات العبثية — أكسبه سريعًا اعترافًا واسعًا وعروضًا مكتملة الحضور في أرجاء فرنسا.`,
    style: 'فكاهة مقتضبة، أداء محرج، كوميديا عبثية، سطحية مقصودة',
    achievements: [
      'نجاح فيروسي هائل على وسائل التواصل الاجتماعي',
      'عروض مكتملة في جميع أنحاء فرنسا',
      'شخصية اختراقية في الستاند أب الفرنسي الحديث',
    ],
  },
];
